export default function throttle (fn, wait = 800) {
  let time = 0
  return function () {
    const _this = this
    const args = arguments
    const now = Date.now()
    if (now - time > wait) {
      fn.apply(_this, args)
      time = now
    }
  }
}
